import { ViewState } from "redux/constants/App";
import * as Types from "../constants/InitFormConstants";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
    records: [],
    error: {
        status: null,
        message: null,
        errors: [],
    },
    getStatus: ViewState.IDLE
}

const actions = {
    [Types.FETCH_RECORDS]: (state) => setBusy({ state, statusKey: "getStatus" }),
    [Types.FETCH_RECORDS_FAILED]: (state, error) => setError({ state, statusKey: "getStatus", error }),
    [Types.FETCH_RECORDS_OK]: (state, records) => setReady({ state, statusKey: "getStatus", payload: { records } }),
}

export default function (state = initialState, { type: actionType, payload }) {
    const action = actions[actionType];
    if (action) return action(state, payload);
    return state;
}